import { render, staticRenderFns } from "./SearchField.vue?vue&type=template&id=2fa60008&scoped=true"
import script from "./SearchField.vue?vue&type=script&lang=js"
export * from "./SearchField.vue?vue&type=script&lang=js"
import style0 from "./SearchField.vue?vue&type=style&index=0&id=2fa60008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa60008",
  null
  
)

export default component.exports